import { ArrowForwardIcon } from "@/components/appIcons";
import { Link } from "@/components/link";
import { featurePageCardStyle } from "@/features/feature-page/feature-page-card-style";
import { FeaturePageVisual } from "@/features/feature-page/feature-page-visual";
import type { ResolvedFeaturePageVisual } from "@garimpa/api/featurePages/types";

export function ArtistHubDirectorySection({
  title,
  items,
  directoryLabel,
}: {
  title: string;
  items: Array<{
    pageId: string;
    label: string;
    path: string;
    image: ResolvedFeaturePageVisual | null;
    accent: string | null;
  }>;
  directoryLabel: (label: string) => string;
}) {
  return (
    <section aria-labelledby={`artist-hub-${title.toLowerCase().replaceAll(" ", "-")}`}>
      <h2
        id={`artist-hub-${title.toLowerCase().replaceAll(" ", "-")}`}
        className="text-2xl font-black tracking-[-0.03em] sm:text-3xl"
      >
        {title}
      </h2>
      <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 lg:gap-4">
        {items.map((item) => (
          <li key={item.pageId}>
            <Link
              className="group relative isolate flex min-h-40 items-end justify-between gap-4 overflow-hidden rounded-2xl bg-zinc-950 px-5 py-5 font-bold text-white shadow-md transition-[transform,box-shadow] duration-500 ease-out hover:-translate-y-1 hover:shadow-xl focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background active:translate-y-0 motion-reduce:transform-none motion-reduce:transition-none sm:min-h-44 sm:px-6 sm:py-6"
              style={featurePageCardStyle(Boolean(item.image), item.accent)}
              to={item.path}
            >
              {item.image ? (
                <FeaturePageVisual
                  visual={{
                    ...item.image,
                    sizes: "(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw",
                  }}
                  decorative
                  className="absolute inset-0 -z-20 h-full w-full object-cover transition duration-700 ease-out group-hover:scale-105 motion-reduce:transition-none"
                />
              ) : null}
              <span className="absolute inset-0 -z-10 bg-gradient-to-t from-black via-black/55 to-black/10 transition-colors duration-500 group-hover:via-black/40" />
              <span className="max-w-[85%] text-lg leading-tight drop-shadow-sm sm:text-xl">
                {directoryLabel(item.label)}
              </span>
              <ArrowForwardIcon
                className="shrink-0 text-xl transition-transform duration-300 group-hover:translate-x-1"
                aria-hidden="true"
              />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
